import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import ApiClient from "#/redux/api/ApiClient";
import { getErrorMessage } from "#/utils/APIUtils";

const baseUrl = "/api/sif/prodajaSemenaRazlogPrepoved";

export const fetchProdajaSemenaRazlogPrepoved = createAsyncThunk(
  "prodajaSemenaRazlogPrepoved/list",
  async (_, { rejectWithValue }) => {
    // eslint-disable-next-line no-console
    console.warn("Deprecated, migrate to LookupTable hooks and components");

    try {
      const response = await ApiClient.get(baseUrl);
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

export const fetchProdajaSemenaRazlogPrepovedPage = createAsyncThunk(
  "prodajaSemenaRazlogPrepoved/page",
  async ({ page, filter, sort }, { rejectWithValue }) => {
    // eslint-disable-next-line no-console
    console.warn("Deprecated, migrate to LookupTable hooks and components");

    try {
      const response = await ApiClient.get(
        `${baseUrl}/page`,
        null,
        page,
        filter,
        sort
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

export const fetchProdajaSemenaRazlogPrepovedBySifra = createAsyncThunk(
  "prodajaSemenaRazlogPrepoved/byCode",
  async (sifra, { rejectWithValue }) => {
    // eslint-disable-next-line no-console
    console.warn("Deprecated, migrate to LookupTable hooks and components");

    try {
      const response = await ApiClient.get(`${baseUrl}/${sifra}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

export const saveProdajaSemenaRazlogPrepoved = createAsyncThunk(
  "prodajaSemenaRazlogPrepoved/save",
  async (dto, { rejectWithValue }) => {
    // eslint-disable-next-line no-console
    console.warn("Deprecated, migrate to LookupTable hooks and components");

    try {
      const response = await ApiClient.post(baseUrl, dto);
      return response.data.output;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

export const updateProdajaSemenaRazlogPrepoved = createAsyncThunk(
  "prodajaSemenaRazlogPrepoved/update",
  async ({ sifra, dto }, { rejectWithValue }) => {
    // eslint-disable-next-line no-console
    console.warn("Deprecated, migrate to LookupTable hooks and components");

    try {
      const response = await ApiClient.put(`${baseUrl}/${sifra}`, dto);
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

export const deleteProdajaSemenaRazlogPrepoved = createAsyncThunk(
  "prodajaSemenaRazlogPrepoved/delete",
  async ({ sifra, version }, { rejectWithValue }) => {
    // eslint-disable-next-line no-console
    console.warn("Deprecated, migrate to LookupTable hooks and components");

    try {
      const response = await ApiClient.delete(
        `${baseUrl}/${sifra}?version=${version}`
      );
      return response.data.output;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

const prodajaSemenaRazlogPrepovedSlice = createSlice({
  name: "prodajaSemenaRazlogPrepoved",
  initialState: {
    list: [], // Empty array for code list
    page: null, // Paginated data
    byId: {}, // Cache for individual items by sifra
    details: null, // Currently selected item identifier
    error: null,
    isLoading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // List fetch - populates both list and byId cache
      .addCase(fetchProdajaSemenaRazlogPrepoved.fulfilled, (state, action) => {
        state.isLoading = false;
        state.list = action.payload;

        // Populate byId cache for all items
        action.payload.forEach((item) => {
          state.byId[item.sifra] = item;
        });
      })
      // Individual fetch - updates byId cache and details
      .addCase(
        fetchProdajaSemenaRazlogPrepovedBySifra.fulfilled,
        (state, action) => {
          state.isLoading = false;
          const item = action.payload;
          if (item?.sifra) {
            state.byId[item.sifra] = item;
            state.details = item.sifra; // Track current selection
          }
        }
      )
      // Save/Update operations
      .addCase(saveProdajaSemenaRazlogPrepoved.fulfilled, (state, action) => {
        state.isLoading = false;
        const item = action.payload;
        if (item?.sifra) {
          state.list.push(item);
          state.byId[item.sifra] = item;
        }
      })
      .addCase(updateProdajaSemenaRazlogPrepoved.fulfilled, (state, action) => {
        state.isLoading = false;
        const item = action.payload;
        if (item?.sifra) {
          state.byId[item.sifra] = item;
          const index = state.list.findIndex((i) => i.sifra === item.sifra);
          if (index !== -1) {
            state.list[index] = item;
          }
        }
      })
      // Delete operation
      .addCase(deleteProdajaSemenaRazlogPrepoved.fulfilled, (state, action) => {
        state.isLoading = false;
        const deletedSifra = action.payload;
        if (deletedSifra) {
          delete state.byId[deletedSifra];
          state.list = state.list.filter((item) => item.sifra !== deletedSifra);
          if (state.details === deletedSifra) {
            state.details = {};
          }
        }
      })
      // Page fetch
      .addCase(
        fetchProdajaSemenaRazlogPrepovedPage.fulfilled,
        (state, action) => {
          state.isLoading = false;
          state.page = action.payload;
        }
      )
      // Standard loading/error handlers
      .addMatcher(
        (action) => action.type.endsWith("rejected"),
        (state, action) => {
          state.isLoading = false;
          state.error = action.payload;
        }
      )
      .addMatcher(
        (action) => action.type.endsWith("pending"),
        (state) => {
          state.isLoading = true;
          state.error = null;
        }
      );
  },
});

export default prodajaSemenaRazlogPrepovedSlice.reducer;
